import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { ReactNode } from 'react';
import { ButtonsSettings, StyledDialog } from 'components/dialog/Dialog.styles.tsx';
import { useKeyboard } from 'hooks/useKeyboard';

export type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  children: ReactNode;
  title: string;
  buttonsSettings?: ButtonsSettings;
  confirmLoading?: boolean;
  confirmDisabled?: boolean;
};

const ConfirmationDialog = ({
  children,
  onCancel,
  onConfirm,
  open,
  title,
  buttonsSettings,
  confirmLoading,
  confirmDisabled,
}: Props) => {
  useKeyboard({
    keyDown: (e) => {
      if (e.key === 'Enter' && open && !confirmLoading && !confirmDisabled) {
        onConfirm();
      }
    },
  });

  const handleCancle = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onCancel) {
      onCancel();
    }
  };

  const handleConfirm = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <StyledDialog open={open} onClose={onCancel} onClick={(e) => e.stopPropagation()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button color={buttonsSettings?.cancelColor ?? 'secondary'} variant="outlined" onClick={handleCancle}>
          {buttonsSettings?.cancelText ?? 'Cancel'}
        </Button>
        <LoadingButton
          color={buttonsSettings?.confirmColor ?? 'primary'}
          variant="contained"
          onClick={handleConfirm}
          loading={confirmLoading}
          disabled={confirmDisabled}
        >
          {buttonsSettings?.confirmText ?? 'Submit'}
        </LoadingButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default ConfirmationDialog;
